export const URLS = {
  AUTH_USERS_MANAGEMENT: 'bakery/admin/usersManagement',
  AUTH_ZONES: 'bakery/admin/zones',
  AUTH_REGIONS: 'bakery/admin/regions',
  AUTH_STORES: 'bakery/admin/stores',
  AUTH_GROWTH: 'bakery/admin/growth',
  AUTH_CLUSTERS: 'bakery/admin/clusters',
  AUTH_FAMILIES: 'bakery/admin/families',
  AUTH_FAMILY_PRODUCTS: 'bakery/admin/family-products',
  AUTH_USAGE_REPORT: 'bakery/admin/usage-report',
  AUTH_PRODUCTS: 'bakery/admin/products',
  AUTH_SALES_CADENTIER: 'bakery/admin/sales-cadentier',
  AUTH_INGREDIENTS: 'bakery/admin/ingredients',

  /* Formator role */
  AUTH_PRODUCT_MANAGEMENT: 'bakery/formator/product-management-formator',
  AUTH_PRODUCTION_MANAGEMENT: 'bakery/formator/cadentier-formator',
  AUTH_PRODUCTION_MANAGEMENT_PRINT: 'bakery/formator/cadentier-formator-print',
  AUTH_STORE_GROWTH_COEFFICIENT: 'bakery/formator/product-growth-index-formator',
  AUTH_PRODUCTS_GROWTH_COEFFICIENT: 'bakery/formator/growth-index-formator',
  AUTH_REGION_GROWTH_COEFFICIENT: 'bakery/formator/growth-region-formator',
  AUTH_APPLICATION_USAGE_REPORT: 'bakery/formator/usage-report-formator',
  AUTH_CADENTIER_REPORT_AND_SALES: 'bakery/formator/sales-cadentier-formator',
  AUTH_REPORT_OWN_PRODUCTION_TRACEABILITY_FORMATOR:
    'bakery/formator/own-production-traceability-report',
  AUTH_REPORT_OWN_PRODUCTION_TRACEABILITY_PRINT_FORMATOR:
    'bakery/formator/own-production-traceability-report-print',
  AUTH_REPORT_FROZEN_TRACEABILITY_FORMATOR: 'bakery/formator/frozen-traceability-report',
  AUTH_REPORT_FROZEN_TRACEABILITY_PRINT_FORMATOR:
    'bakery/formator/frozen-traceability-report-print',

  /* Store manager role */
  AUTH_PRODUCT_MANAGEMENT_STORE: 'bakery/storeManager/product-management',
  AUTH_PRODUCT_GROWTH_INDEX: 'bakery/storeManager/product-growth-index',
  AUTH_PRODUCTION_MANAGEMENT_STORE: 'bakery/storeManager/cadentier-store',
  AUTH_PRODUCTION_MANAGEMENT_STORE_PRINT: 'bakery/storeManager/cadentier-store-print',
  AUTH_GROWTH_INDEX_STORE: 'bakery/storeManager/growth-index',
  AUTH_REPORT_AND_SALES_STORE: 'bakery/storeManager/cadentier-sales-store',

  /* Region manager role */
  AUTH_PRODUCT_MANAGEMENT_REGION: 'bakery/regionManager/product-management-region',
  AUTH_CADENTIER_SALES_REGION: 'bakery/regionManager/cadentier-sales-region',
  AUTH_USAGE_REPORT_REGION: 'bakery/regionManager/usage-report-region',
  AUTH_GROWTH_INDEX: 'bakery/regionManager/growth-index',
  AUTH_GROWTH_INDEX_VIEW: 'bakery/regionManager/growthIndexView',
  AUTH_GROWTH_INDEX_PRODUCTS_VIEW: 'bakery/regionManager/growthIndexProductsView',
  AUTH_GROWTH_REGION: 'bakery/regionManager/growth-region',
  AUTH_GROWTH_REGION_PRINT: 'bakery/regionManager/cadentier-region-print',

  /* Region manager role */
  AUTH_PRODUCT_MANAGEMENT_TRACEABILITY: 'bakery/traceabilityOperator/product-management',
  AUTH_RECEIVED_PRODUCTS_TRACEABILITY: 'bakery/traceabilityOperator/received-products',
  AUTH_FROZEN_TRACEABILITY: 'bakery/traceabilityOperator/frozen-traceability',
  AUTH_REPORT_FROZEN_TRACEABILITY: 'bakery/traceabilityOperator/frozen-traceability-report',
  AUTH_REPORT_FROZEN_TRACEABILITY_PRINT:
    'bakery/traceabilityOperator/frozen-traceability-report-print',
  AUTH_OWN_PRODUCTION_TRACEABILITY: 'bakery/traceabilityOperator/own-production-traceability',
  AUTH_REPORT_OWN_PRODUCTION_TRACEABILITY:
    'bakery/traceabilityOperator/own-production-traceability-report',
  AUTH_REPORT_OWN_PRODUCTION_TRACEABILITY_PRINT:
    'bakery/traceabilityOperator/own-production-traceability-report-print'
}
